// extracted by mini-css-extract-plugin
export var container = "_vj-0";
export var table = "_vj-2";
export var tableWrapper = "_vj-1";